import withFlags from './withFlags';

export {
  withFlags
};

export default withFlags;
